import { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { REMOVE_SOONEST_DELIVERY } from '@/vdp/VehicleDetailsContainer/actionTypes';
import ActivityType from '~/constants/activityType';
import LocationContext from '~/context/vdp/LocationContext';
import { getDeliveryPickup } from '~/selectors';

// TODO: Can we remove this now?
function useDirectDeliveryContext() {
  const {
    deliveryContext: {
      data: { isDeliveryAllowed = true }
    }
  } = useContext(LocationContext);
  const dispatch = useDispatch();
  const {
    data: { soonestDelivery }
  } = useSelector(getDeliveryPickup);

  useEffect(() => {
    // Temporarily use delivery context to control Direct Delivery
    if (
      soonestDelivery.content?.activityType === ActivityType.DirectDelivery &&
      !isDeliveryAllowed
    ) {
      dispatch({ type: REMOVE_SOONEST_DELIVERY });
    }
  }, [dispatch, isDeliveryAllowed, soonestDelivery?.content?.activityType]);
}

export default useDirectDeliveryContext;
